import GuidePrivateTripCard from "components/TripCard/GuidePrivateTripCard";
import { getGuidePrivateTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import ButtonSecondary from "shared/Button/ButtonSecondary";

const PrivateTripListGuide = () => {
    const { listing, user } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    useEffect(() => {
        if (listing.guidePrivateTripList == null) {
            dispatch(getGuidePrivateTrip());
        }
    }, [listing, listing.guidePrivateTripList])

    return (<>
        <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
            {listing.guidePrivateTripList && (listing.guidePrivateTripList).map((stay: IProduct) => (
                <GuidePrivateTripCard key={stay.id} data={stay} user={user} />
            ))}
        </div>
        <div className="flex mt-11 justify-center items-center">
            {listing.guidePrivateTripList == null &&
                <Loader
                    type="Circles"
                    color="#d24e29"
                    height={25}
                    width={25}
                />}
        </div>
    </>);
}

export default PrivateTripListGuide;